module.exports = __webpack_public_path__ + "media/winter_2025_sweepstakes/tiktok-8151c505.svg";